module.exports = __webpack_public_path__ + "static/media/html5.7997c424.svg";